// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".speaker-stats .avatar-default-icon {\n  min-width: 36px !important;\n  min-height: 36px !important;\n}", ""]);
// Exports
module.exports = exports;
